import { render, staticRenderFns } from "./SOSSetPage.vue?vue&type=template&id=9befbc8a&scoped=true&"
import script from "./SOSSetPage.vue?vue&type=script&lang=js&"
export * from "./SOSSetPage.vue?vue&type=script&lang=js&"
import style0 from "./SOSSetPage.vue?vue&type=style&index=0&id=9befbc8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9befbc8a",
  null
  
)

export default component.exports